export default __webpack_public_path__ + "static/media/portfolio-40.070dab16.jpg";